module.exports = __webpack_public_path__ + "static/media/crypto_tomb_cash.7e1ef382.png";